export class MeasureUnitModel{
  id: number;
  name: string;
  isActive:boolean=true;
}
